import React from "react"
import { useTranslation } from "gatsby-plugin-react-i18next"
import {
  Container,
  Section,
  SectionHead,
  ReferenceImage,
  Button,
} from "src/components/common"
import { scrollToAnchor } from "src/utils/scroll"
import {
  Grid,
  Card,
  Media,
  Body,
  Role,
  Result,
  Tags,
  Links,
  MoreTitle,
  MoreList,
  Note,
} from "./styles"

const ExternalLinks = ({ links, note }) =>
  links && links.length ? (
    <Links>
      {links.map(link => (
        <a
          key={link.url}
          href={link.url}
          target="_blank"
          rel="noopener noreferrer"
        >
          {link.title} <span className="sr-only">({note})</span>
        </a>
      ))}
    </Links>
  ) : null

export const Projects = () => {
  const { t } = useTranslation()
  const featured = t("projects:featured", { returnObjects: true })
  const more = t("projects:more", { returnObjects: true })
  const note = t("external_link")

  return (
    <Section id="references" aria-labelledby="references-title">
      <Container>
        <SectionHead
          id="references-title"
          title={t("projects:headline")}
          lead={t("projects:lead")}
        />
        <Grid>
          {featured.map(project => (
            <Card
              key={project.id}
              id={`project-${project.id}`}
              aria-labelledby={`project-${project.id}-title`}
            >
              <Media style={{ background: project.color }}>
                <ReferenceImage
                  filename={project.image}
                  alt={`${t("projects:screenshot_alt")} ${project.title}`}
                />
              </Media>
              <Body>
                <h3 id={`project-${project.id}-title`}>{project.title}</h3>
                <Role>{project.role}</Role>
                <p>{project.text}</p>
                {project.result ? (
                  <Result>
                    <strong>{t("projects:result_label")}:</strong>{" "}
                    {project.result}
                  </Result>
                ) : null}
                {project.tags ? <Tags>{project.tags.join(", ")}</Tags> : null}
                <ExternalLinks links={project.links} note={note} />
              </Body>
            </Card>
          ))}
        </Grid>
        <MoreTitle id="more-projects">{t("projects:more_headline")}</MoreTitle>
        <MoreList aria-labelledby="more-projects">
          {more.map(project => (
            <li key={project.id} id={`project-${project.id}`}>
              <div>
                <h4>{project.title}</h4>
                <Role>{project.role}</Role>
              </div>
              <div>
                <p>{project.text}</p>
                <ExternalLinks links={project.links} note={note} />
              </div>
            </li>
          ))}
        </MoreList>
        <Note>
          <div>
            <h3>{t("projects:nda_title")}</h3>
            <p>{t("projects:nda_note")}</p>
          </div>
          <Button $variant="secondary" href="#contact" onClick={scrollToAnchor}>
            {t("projects:nda_cta")}
          </Button>
        </Note>
      </Container>
    </Section>
  )
}
